import Index from '@/frontend/pages/IndexPage'

import NotFound from '@/frontend/pages/NotFoundPage'
import AuthorsPage from '@/frontend/pages/AuthorsPage'
import AuthorPage from '@/frontend/pages/AuthorPage'
import CompilationsPage from '@/frontend/pages/CompilationsPage'
import CompilationPage from '@/frontend/pages/CompilationPage'
import WorksPage from '@/frontend/pages/WorksPage'
import WorkPage from '@/frontend/pages/WorkPage'
import UserWorkPage from '@/frontend/pages/UserWorkPage'
import LoginPage from '@/frontend/pages/LoginPage'
import RecoveryPasswordPage from '@/frontend/pages/RecoveryPasswordPage'
import NewPasswordPage from '@/frontend/pages/NewPasswordPage'
import RegistrationPage from '@/frontend/pages/RegistrationPage'
import MailVerificationPage from '@/frontend/pages/MailVerificationPage'
import SellWorkPage from '@/frontend/pages/SellWorkPage'
import CategoryPage from '@/frontend/pages/CategoryPage'
import ProfilePage from '@/frontend/pages/ProfilePage'
import ProfileInfoPage from '@/frontend/pages/profile/ProfileInfoPage'
import ProfileCompilationPage from '@/frontend/pages/profile/ProfileCompilationPage'
import ProfileCompilationsPage from '@/frontend/pages/profile/ProfileCompilationsPage'
import ProfileCompilationFormPage from '@/frontend/pages/profile/ProfileCompilationFormPage'
import VerifyEmailPage from '@/frontend/pages/VerifyEmailPage'
import OldAboutPage from '@/frontend/pages/OldAboutPage'
import AboutPage from '@/frontend/pages/AboutPage'
import ContactsPage from '@/frontend/pages/ContactsPage'
import WhatOfferPage from '@/frontend/pages/WhatOfferPage'
import SearchPage from '@/frontend/pages/SearchPage'


export default (store) => {
    return [
        { path: '', component: Index},
        { name: 'main', path: '/', component: Index},
        { name: 'authors', path: '/authors', component: AuthorsPage },
        { name: 'author', path: '/authors/:id', component: AuthorPage },
        { name: 'compilations', path: '/compilations', component: CompilationsPage },
        { name: 'compilation', path: '/compilations/:id', component: CompilationPage },
        { name: 'works', path: '/works', component: WorksPage },
        { name: 'work', path: '/works/:id', component: WorkPage },
        { name: 'user-work', path: '/user-works/:id', component: UserWorkPage },
        { name: 'sign-in', path: '/sign-in', component: LoginPage, props: true, beforeEnter: (to, from) => {
                if (!store.getters.can('isGuest')) return from
            } },
        { name: 'recovery-password', path: '/recovery-password', component: RecoveryPasswordPage, beforeEnter: (to, from) => {
                if (!store.getters.can('isGuest')) return from
            }  },
        { name: 'new-password', path: '/recovery-password/:hash', component: NewPasswordPage, beforeEnter: (to, from) => {
                if (!store.getters.can('isGuest')) return from
            }  },
        { name: 'sign-up', path: '/sign-up', component: RegistrationPage, beforeEnter: (to, from) => {
                if (!store.getters.can('isGuest')) return from
            }  },
        { name: 'verify-email', path: '/verify-email/:token', component: VerifyEmailPage, beforeEnter: (to, from) => {
                if (!store.getters.can('isGuest')) return from
            }  },
        { name: 'verification', path: '/verification', component: MailVerificationPage, beforeEnter: (to, from) => {
                if (!store.getters.can('isGuest') || !store.getters.email) return from
            }  },
        { name: 'sell-work', path: '/sell-work', component: SellWorkPage },
        { name: 'category', path: '/categories/:id', component: CategoryPage },
        {
            name: 'profile', path: '/profile', component: ProfilePage,
            beforeEnter: (to, from) => {
                if (store.getters.can('isGuest')) return from
            },
            children: [
                { name: 'profile/info', path: '', component: ProfileInfoPage },
                { name: 'profile/compilations', path: 'compilations', component: ProfileCompilationsPage },
                { name: 'profile/compilation', path: 'compilations/:id', component: ProfileCompilationPage },
                { name: 'profile/compilation-create', path: 'compilations/create', component: ProfileCompilationFormPage },
                { name: 'profile/compilation-update', path: 'compilations/update/:id', component: ProfileCompilationFormPage },
            ]
        },
        { name: 'about', path: '/about', component: AboutPage },
        { name: 'about-old', path: '/about-old', component: OldAboutPage },
        { name: 'contacts', path: '/contacts', component: ContactsPage },
        { name: 'what-offer', path: '/what-offer', component: WhatOfferPage },
        { name: 'search', path: '/search', component: SearchPage, props: route => ({q: route.query.q || ''}) },
        { name: 'not-found', component: NotFound },
        { path: '/:catchAll(.*)', component: NotFound },
    ]
}